import { ROUTES_CONFIG } from "@/constants"
import { constructUrl } from "@/utils/constructUrl"
import { openWindow } from "@/utils/openWindow"

import { tearOut } from "./tearOut.state"

export const handleTearOut = (symbol: string) =>
  openWindow(
    {
      url: constructUrl(ROUTES_CONFIG.tile.replace(":symbol", symbol)),
      name: symbol,
      width: 380,
      height: 172,
    },
    () => tearOut(symbol, false),
  )
